// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 94 ? "pdfjsWorker" : chunkId) + "." + {"94":"734b6533","787":"0eef9aee"}[chunkId] + ".chunk.js";
};